import { TagService } from '../../../services/tag.service';
import { MemberTagsEditRequest } from '../../../models/ss-api/requests/tag.edit.request';
import { ssApiService } from '../../../services/ss-api.service';
import { TagArray, TagItem, TagTypes, TagTOSTypes } from '../../../models/domain/tag';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseResponse } from '../../../models/comm-http/responses/BaseResponse';
import { StringResponse } from '../../../models/ss-api/responses/string.response';
import { SweetAlertService } from 'ng2-cli-sweetalert2';

@Component({
    selector: 'tags',
    templateUrl: './tags.component.html',
    styleUrls: ['./tags.component.css']
})
export class TagsComponent {

    // inputs
    @Input('Tags') Tags: TagArray;
    @Input('TagType') TagType: TagTypes;
    @Input('RelationID') RelationID: number;

    // events
    @Output('BusyChanged') BusyChanged = new EventEmitter<boolean>();
    @Output('TagsChanged') TagsChanged = new EventEmitter();

    // vars
    EditTags: boolean = false;
    IsBusy: boolean = false;
    BusyAction: string = 'Loading ...';
    Edited: boolean = false;
    TOSTagChanged: boolean = false;

    //
    PossibleTags: TagArray;


    constructor(private tagService: TagService, private ssdb2: ssApiService, private sweetAlertService: SweetAlertService) {

    }


    setBusyLoading() {
        this.BusyAction = 'Loading ...';
        this.IsBusy = true;
    }

    setBusySaving() {
        this.BusyAction = 'Saving ...';
        this.IsBusy = true;
    }

    unsetBusy() {
        this.IsBusy = false;
    }



    EditLoad() {
        this.setBusyLoading();

        let subscr = this.tagService.onAllPossibleTagsLoaded.subscribe(
            () => {
                // after tags loaded from server
                this.LoadAllPossibleTagsByType();
                this.MapSelected();

                this.unsetBusy();
                this.EditTags = !this.EditTags;
                subscr.unsubscribe();
            }
        )

        this.tagService.LoadAllPossibleTags();
    }


    async SaveEdit() {

        if (this.Edited == false) {

            this.EditTags = false;
            return;

        }

        // saving
        this.setBusySaving();

        // prepare request object
        let request = this.GetRequest();

        // check if we have TOS flag
        let tosCheckedAndConfirmed = await this.checkConfirmTOSFlag(request);
        if (!tosCheckedAndConfirmed)
            return;


        // invoke
        this.ssdb2.MemberTagsEdit(request).subscribe(

            (result: BaseResponse<StringResponse>) => {
                if (result.Result) {
                    this.unsetBusy();
                    this.EditTags = !this.EditTags;
                    this.TagsChanged.emit(request);
                    this.TOSTagChanged = false;
                } else {
                    this.BusyAction = 'Error';
                }
            },

            (error: any) => {
                this.BusyAction = 'Error';
            }

        )
    }

    private async checkConfirmTOSFlag(request: MemberTagsEditRequest): Promise<boolean> {

        let tosTag = this.PossibleTags.find(tag => tag.TagTOSType == TagTOSTypes.TOS);

        let tosFlagIndex = request.TagItemIDs.findIndex(x => x == tosTag.ID);
        if (tosFlagIndex < 0 || this.TOSTagChanged == false)
            return true;


        let result = await this.sweetAlertService.swal(
            {
                title: 'Add TOS Flag',
                text: 'Are you sure you want to add a TOS flag and monitor this account?',
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Yes, add TOS',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,

            })
            .then(response => {
                return true;
            }, (dismiss) => {
                return false;
            })
            .catch(error => {
                return false;
            });


        return result;
    }

    private GetRequest(): MemberTagsEditRequest {

        let request = new MemberTagsEditRequest();
        request.RelationID = this.RelationID;
        request.TagItemIDs = new Array<number>();

        // add all tag id's
        this.Tags.forEach((tag) => { request.TagItemIDs.push(tag.ID) })

        return request;

    }

    TagSelectionChanged(tag: TagItem) {

        this.Edited = true;

        if (tag.TagTOSType == TagTOSTypes.TOS)
            this.TOSTagChanged = true;

        if (tag.Selected == true) {
            // add
            this.Tags.push(tag);
        } else {
            // delete from current selection
            let index = this.Tags.findIndex(t => t.ID == tag.ID);
            this.Tags.splice(index, 1);
        }
    }

    LoadAllPossibleTagsByType() {
        let defaultTagType = 0;
        let tagType = this.TagType;

        if (!this.TagType)
            tagType = defaultTagType;
        else
            tagType = this.TagType;

        switch (tagType) {
            case TagTypes.Member:
                this.PossibleTags = this.tagService.FilterAllPossibleMemberTags();
                break;

            default:
                throw new Error('not implemented');
        }


    }

    SetTags(tags: TagArray) {

        this.Tags = tags;
        this.MapSelected();
    }


    CheckSelectedTags(tag: TagItem): boolean {

        if (!this.Tags)
            return false;

        let result = false;

        this.Tags.forEach((tagItem) => {
            if (tagItem.ID == tag.ID) {
                result = true;
                return;
            }
        })

        return result;

    }



    private MapSelected(): void {

        if (!this.PossibleTags)
            return;

        this.PossibleTags.forEach((tag) => {
            tag.Selected = this.CheckTagExistByID(this.Tags, tag.ID);
        });
    }

    private CheckTagExistByID(tags: TagArray, id: number): boolean {

        let result = false;

        tags.forEach((tagItem) => {
            if (tagItem.ID == id) {
                result = true;
                return;
            }
        })

        return result;

    }

    LoadMemberTags(memberID: number = this.RelationID) {

        this.ssdb2.SearchMemberTags(memberID).subscribe(

            (result: BaseResponse<TagArray>) => {
                this.SetTags(result.Data);
            },

            (error: any) => {
                this.BusyAction = 'Error';
            }

        )


    }

    private Save() {

        let request = new MemberTagsEditRequest();
        request.RelationID = this.RelationID;

        let tagIds = new Array<number>();

    }

}
